
import { format_price } from "../../utils/cart-utils";

////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div class="c-cart-total">
        <div class="c-cart-total_inner">
            <div class="c-cart-total_upsell" v-if="upsellProducts.length > 0">
                <div class="c-cart-total_upsell_inner">
                    <figure class="c-figure c-cart-total_upsell_visual">
                        <div class="c-figure_inner || o-lazy">
                            <img
                                class="c-figure_image || o-lazy_image -lazy-loaded"
                                :src="upsellProducts[0].selected_or_first_available_variant.featured_image ? upsellProducts[0].selected_or_first_available_variant.featured_image.src : upsellProducts[0].product.featured_image | imageUrl"
                                :alt="upsellProducts[0].selected_or_first_available_variant.title"
                                width="114"
                                height="114"
                            >
                        </div>
                    </figure>

                    <div class="c-cart-total_upsell_content">
                        <div>
                            <h3 class="c-text">
                                <a :href="upsellProducts[0].url">
                                    {{ upsellProducts[0].product.title }}
                                </a>
                            </h3>

                            <p class="c-cart-total_upsell_excerpt || c-text">{{ upsellProducts[0].product.description | truncateString }}</p>
                        </div>

                        <div class="c-cart-total_upsell_bottom">
                            <div>
                                <p class="c-cart-item_price">
                                    <span v-if="upsellProducts[0].selected_or_first_available_variant.compare_at_price" class="c-cart-item_price_original || c-text">{{ upsellProducts[0].selected_or_first_available_variant.compare_at_price | price }}</span>
                                    <span class="c-cart-item_price_current || c-text">{{ upsellProducts[0].selected_or_first_available_variant.price | price }}</span>
                                </p>
                            </div>

                            <div>
                                <button type="button" class="c-button -white" v-on:click="addToCart(upsellProducts[0].selected_or_first_available_variant.id)">
                                    <slot name="add-to-cart"></slot>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="c-cart-total_inner_container">
                <p class="c-cart-total_hint || c-text -caption">
                    <slot name="hint"></slot>
                </p>

                <div class="c-cart-total_recap || c-text -caption">
                    <p class="c-cart-total_recap_item -total || c-text -medium">
                        <span>{{ subtotalLabel }} : {{ total | price }}</span>
                    </p>
                </div>
            </div>

            <form class="c-cart-total_form" :action="checkoutAction" method="post">
                <button class="c-button -big -fluid -center -spinner" type="submit" name="checkout" :disabled="!isCheckoutAvailable">
                    <span class="c-button_label">
                        <slot name="checkout-label"></slot>
                    </span>
                    <span class="c-button_spinner">
                        <span class="c-button_spinner_item"></span>
                    </span>
                </button>
            </form>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////
export default function VueCartTotal(moduleInstance) {

    Vue.component("cart-total", {

        template,

        props: {
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            subtotalLabel: {
                type: String,
                required: true
            },
            taxesLabel: {
                type: String,
                required: true
            },
            discountLabel: {
                type: String,
                required: true
            },
            totalLabel: {
                type: String,
                required: true
            },
            upsellProductList: {
                type: String,
                required: false
            },
            checkoutAction: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                isCheckoutAvailable: false,
                total: {
                    amount: '',
                    currencyCode: ''
                },
                subtotal: {
                    amount: '',
                    currencyCode: ''
                },
                taxes: {
                    amount: '',
                    currencyCode: ''
                },
                upsellProducts: []
            };
        },

        computed: {
            currentTotal() {
                const total = this.total.amount ? this.total.amount : 0
                return format_price((parseFloat(total, 10) * 100), this.currencySymbol, this.currencyIsoCode)
            },

            currentSubtotal() {
                const subtotal = this.subtotal.amount ? this.subtotal.amount : 0
                return format_price((parseFloat(subtotal, 10) * 100), this.currencySymbol, this.currencyIsoCode)
            },

            currentTaxes() {
                const taxes = this.taxes.amount ? this.taxes.amount : 0
                return format_price((parseFloat(taxes, 10) * 100), this.currencySymbol, this.currencyIsoCode)
            },

            currentSale() {
                return this.showDiscount ? `-${100 - Math.round(this.total.amount / this.subtotal.amount * 100)}%` : ''
            },

            showDiscount() {
                return (parseFloat(this.total.amount, 10) * 100) < (parseFloat(this.subtotal.amount, 10) * 100)
            },

            showTaxes() {
                return this.taxes.amount > 0 ? true : false
            },
        },

        created() {
            if(this.upsellProductList) {
                this.upsellProductList = JSON.parse(this.upsellProductList)

                this.upsellProducts = this.filterUpsellProducts()
            }
        },

        mounted() {

        },

        methods: {
            setCheckoutAvailability(state) {
                this.isCheckoutAvailable = state
            },

            setTotalData(total) {
                this.total = total
            },

            filterUpsellProducts() {
                const upsellProducts = []

                for (let index = 0; index < this.upsellProductList.length; index++) {
                    const product = this.upsellProductList[index];
                    if(product && product.selected_or_first_available_variant.available == true) upsellProducts.push(product)
                }

                return upsellProducts;
            },

            updateUpsellProducts(items) {
                items.forEach((item) => {
                    if(this.upsellProducts.length > 0) {
                        if(item.product_id == this.upsellProducts[0].product.id.toString()) {
                            this.upsellProducts.shift()
                        }
                    }
                })
            },

            addToCart(variantId) {
                const formData = {
                    items: [
                        {
                            id: variantId,
                            quantity: 1,
                        },
                    ],
                };
                moduleInstance.call("addToCart", { formData: formData, openCart: true }, "Cart");
            }
        },

        filters: {
            truncateString: function (str) {
                let num = 100

                let cleanedString = str.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ' ');


                if (cleanedString.length <= num) {
                    return cleanedString
                }
                return cleanedString.slice(0, num) + '...'
            },
            price(value) {
                if (typeof value != "number") return value;

                const formattedAmount = new Intl.NumberFormat(window?.Shopify?.locale, {
                    style: 'currency',
                    currencyDisplay: 'narrowSymbol',
                    currency: window?.Shopify?.currency?.active
                }).format(value / 100)

                return formattedAmount;
            },
            imageUrl(value) {
                if (typeof value != "string") return value;
                return `${value}&width=100`;
            },
        }
    });
}
